import { DragAndDropFormats } from "../enums/drag-and-drop.js";

/**
 * Get if `DragAndDropFormats` is a string data type.
 * `string` data types do not need `JSON.stringify` or `JSON.parse` called.
 *
 * @param format DragAndDropFormats | string
 * @returns boolean
 */
var getIsStringDragAndDropFormat = function getIsStringDragAndDropFormat(format) {
  return Object.values(DragAndDropFormats).includes(format);
};
export { getIsStringDragAndDropFormat };